import React from 'react';
import './Verification.css';

function BadgeVerifie() {
  return (
    <span className="badge badge-verified" title="Telephone verifie">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
        <polyline points="22 4 12 14.01 9 11.01"/>
      </svg>
    </span>
  );
}

export default BadgeVerifie;
